import { useFnsServiceGetFormByIdForAdminQuery } from 'zma-react-sdk/fns-service'
import { useTenantStore } from '@/stores/tenantStore'
import { Survey } from '@/features/forms-and-surveys/types'

export function useFormById(formId: string) {
  const { selectedTenantId } = useTenantStore()

  const { data, loading, error } = useFnsServiceGetFormByIdForAdminQuery({
    variables: { id: formId },
    skip: !formId,
    context: {
      headers: {
        'x-tenant-id': selectedTenantId,
      },
    },
  })

  const form: Survey | undefined = data?.fnsServiceGetFormByIdForAdmin

  return {
    data: form,
    loading,
    error,
  }
}
